/**
 * Session guard — единая реакция на потерю UAM-сессии.
 *
 * Правила:
 * - До markbase_auth_ready (checkAuth) shell-401 ожидаемы → молчим.
 * - После authReady + 401 на API → один раз: событие markbase_session_expired
 *   (UI очищает Redux и ведёт на /login с понятным сообщением).
 * - Без polling каждую секунду — только реакция на 401 и мягкий revalidate
 *   при visibility/pageshow (см. AuthInitializer).
 */
let clientAuthReady = false;
let handlingExpiry = false;
let lastExpiryAt = 0;

const EXPIRY_DEDUPE_MS = 4000;

export function setClientAuthReady(isAuthenticated) {
  clientAuthReady = !!isAuthenticated;
  if (isAuthenticated) {
    handlingExpiry = false;
  }
}

export function isClientAuthReady() {
  return clientAuthReady;
}

function isAuthBootstrapUrl(url) {
  const u = String(url || '');
  return (
    /\/api\/auth\/(login|register|refresh|guest|logout)/i.test(u)
    || /\/api\/uam\/v1\/(login|register|logout)/i.test(u)
  );
}

/**
 * @returns {boolean} true если сессия считается потерянной и событие уже отправлено / в полёте
 */
export function reportSessionUnauthorized({ url, status, code } = {}) {
  if (status !== 401) return false;
  if (!clientAuthReady) return false;
  if (isAuthBootstrapUrl(url)) return false;

  const now = Date.now();
  if (handlingExpiry) return true;
  if (now - lastExpiryAt < EXPIRY_DEDUPE_MS) return true;

  handlingExpiry = true;
  lastExpiryAt = now;
  clientAuthReady = false;

  if (typeof window !== 'undefined') {
    try {
      window.dispatchEvent(new CustomEvent('markbase_session_expired', {
        detail: {
          url: String(url || ''),
          code: code || null,
          at: now,
        },
      }));
    } catch {
      /* ignore */
    }
  }
  return true;
}

/** Мин. интервал между мягкими checkAuth при возврате на вкладку */
export const SESSION_REVALIDATE_MIN_MS = 30_000;
